export default class TimeModel {
    start: number;
    end: number;
}
